import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Category } from '@vendasta/executive-report';
import { Breadcrumbs } from '@vendasta/uikit';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PartnerService } from '../../core/partner.service';
import { CustomizeExecReportService } from './customize-exec-report.service';

@Component({
  selector: 'app-customize-exec-report',
  templateUrl: './customize-exec-report.component.html',
  styleUrls: ['./customize-exec-report.component.scss'],
})
export class CustomizeExecReportComponent implements OnInit {
  navSectionElement: any;
  partnerId: string;
  marketId: string;
  categoryOrder$: Observable<Category[]>;
  isReordering$: Observable<boolean> = new Observable(null);
  breadcrumbs: Breadcrumbs[];
  categoriesEnum = Category;

  constructor(
    private execReportService: CustomizeExecReportService,
    private partnerService: PartnerService,
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    combineLatest([this.partnerId$, this.route.params])
      .pipe(
        map(([partnerId, params]: [string, Params]) => {
          this.marketId = params.marketId;
          this.execReportService.getEnabledExecReportCategories(partnerId, params.marketId);
        }),
      )
      .subscribe();

    this.partnerId = this.partnerService.partnerId;
    this.categoryOrder$ = this.execReportService.enabledCategories$;
    this.isReordering$ = this.execReportService.isSavingCategories$;
    this.breadcrumbs = this.buildBreadcrumbs();
  }

  private buildBreadcrumbs(): Breadcrumbs[] {
    let baseUrl = '/customize-design';
    let baseBack2Message = 'Back to Customize Settings';
    if (this.marketId) {
      baseUrl += `/markets/${this.marketId}`;
      baseBack2Message += ` (${this.marketId})`;
    }
    return [{ url: baseUrl, text: baseBack2Message }, { text: 'Executive Report' }];
  }

  isBefore(a: any, b: any): boolean {
    if (a.parentNode === b.parentNode) {
      for (let cur = a; cur; cur = cur.previousSibling) {
        if (cur === b) {
          return true;
        }
      }
    }
    return false;
  }

  dragEnter($event: any): void {
    const target: any = $event.currentTarget;
    if (this.isBefore(this.navSectionElement, target)) {
      target.parentNode.insertBefore(this.navSectionElement, target); // insert before
    } else {
      target.parentNode.insertBefore(this.navSectionElement, target.nextSibling); //insert after
    }
  }

  dragStart($event: any): void {
    this.navSectionElement = $event.currentTarget;
    $event.dataTransfer.effectAllowed = 'move';
  }

  dragEnd($event: any): void {
    const target: any = $event.currentTarget;
    const elements: any = Array.from(target.parentNode.childNodes);
    const firstLevelChildren = elements.filter((child: any) => child.nodeType === 1);
    const categories: Category[] = firstLevelChildren.map((x: any) => +x.dataset.category); // unary op: str to int
    this.execReportService.setConfigReportCategories(this.partnerId, this.marketId, categories);
  }
}
